import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";

import { ActionButtons } from "@components";
import { ServiceHistoryForm } from "./ServiceHistoryForm";

import { ServicesHistoryType } from "@type/HRM/services";
import {
  convertDocumentData,
  revertDocumentData,
} from "@utils/documentDataConvert";
import { serviceHistoryServicesValidation } from "@validations/HRM/employee/sevicesValidation";

interface ServiceHistoryPropsType {
  serviceHistoryInfo: ServicesHistoryType;
  changeServiceHistoryInfo: (data: ServicesHistoryType) => void;
  removeServiceHistoryInfo: (servicesHistoryID: number) => void;
  getServicesRequestOngoing: boolean;
  updateServicesHistoryRequestOngoing: boolean;
  deleteServicesHistoryRequestOngoing: boolean;
  isProfileDisabled: boolean;
}

export const ServiceHistory = ({
  serviceHistoryInfo,
  changeServiceHistoryInfo,
  removeServiceHistoryInfo,
  getServicesRequestOngoing,
  updateServicesHistoryRequestOngoing,
  deleteServicesHistoryRequestOngoing,
  isProfileDisabled,
}: ServiceHistoryPropsType) => {
  const methods = useForm<ServicesHistoryType>({
    resolver: yupResolver(serviceHistoryServicesValidation),
    values: {
      ...revertDocumentData(serviceHistoryInfo),
      accServiceDate: serviceHistoryInfo?.accServiceDate || "",
      gazettedDate: serviceHistoryInfo?.gazettedDate || "",
      confirmationDate: serviceHistoryInfo?.confirmationDate || "",
      seniorityDate: serviceHistoryInfo?.seniorityDate || "",
    } as ServicesHistoryType,
  });

  const { handleSubmit } = methods;
  const onSubmit: SubmitHandler<ServicesHistoryType> = (
    data: ServicesHistoryType,
  ) => {
    changeServiceHistoryInfo(convertDocumentData(data));
  };

  const isSaving =
    getServicesRequestOngoing || updateServicesHistoryRequestOngoing;

  return (
    <>
      <FormProvider {...methods}>
        <form className="container" onSubmit={handleSubmit(onSubmit)}>
          <ServiceHistoryForm isProfileDisabled={isProfileDisabled} />
          {!isProfileDisabled && <ActionButtons isSaving={isSaving} disabled />}
        </form>
      </FormProvider>
    </>
  );
};
